/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DeploymentCheckType {
	HTTP = "http",
	TCP = "tcp",
}
